import { ContactType } from '@client/graphql/__generated__/types';

export const contactTypeLabels: Record<ContactType, string> = {
  [ContactType.AGENT]: 'Agent',
  [ContactType.CLIENT]: 'Client',
  [ContactType.INSURANCE_AGENT]: 'Insurance',
  [ContactType.LOAN_OFFICER]: 'Lender',
  [ContactType.TITLE_AGENT]: 'Title',
};
